export default "/images/heart-filled-icon.png?205c55a59dc31ffa295830c52f4b2a54";